import React from "react";
import * as RR from "react-redux";
import Spinner from "../../../../components/utils/Spinner";
import { IState } from "../../../reducer";
import * as actions from "../actions";
import OrganizationContainer from "../components/OrgList/OrgList.container";

const Preview: React.FC = () => {
  const dispatch = RR.useDispatch();
  const organizations = RR.useSelector((state: IState) => state.App.OrganizationSettings.preview);
  const currentOrganizationName = RR.useSelector(
    (state: IState) => state.App.OrganizationSettings.organization?.displayName
  );

  React.useEffect(() => {
    dispatch(actions.fetchOrganizationPreview());
  }, [currentOrganizationName]);

  if (organizations === undefined) {
    return (
      <div>
        <p>An error has occurred while getting the organization preview.</p>
      </div>
    );
  }

  if (organizations == null) {
    return <Spinner />;
  }

  return <OrganizationContainer {...organizations} />;
};

export default Preview;
